import { Box, Typography } from "@mui/material";

export default function ContactUs() {
    return (
        <Box sx={{display:"flex", justifyContent:"center",alignItems:"center", height:"80vh"}}>
            <Typography sx={{fontSize:"200px"}}>Contact Us</Typography>
        </Box>
    );
}
